import { MemoApproverStatuses } from '@shared/utils/memos.constant';
import {
  OnApproveAction,
  TransformedPreApproveData,
  VerificationAction,
} from 'src/app/modules/s11-e-signature/shared/pre-approve-models';
import { MemoLoaProgress } from 'src/app/modules/memos/model/memo.model';

export type MemoApproverStatus =
  (typeof MemoApproverStatuses)[keyof typeof MemoApproverStatuses];

export interface MemoLoaPreview {
  level: number;
  members: {
    date_of_approve_since?: string;
    date_of_approve?: string;
    email?: string;
    full_name: string;
    is_custom: boolean;
    is_delegate: boolean;
    photo?: string;
    position: string;
    phone_number?: string;
    reason?: string;
    section?: number;
    status: MemoApproverStatus;
    can_send_reminder?: boolean;
    id: number;
    color_profile?: string;
    short_name?: string;
    nickname?: string;
  }[];
  progress: MemoLoaProgress;
  status: MemoApproverStatus;
  signature_required: boolean;
}

// Define the state model
export interface PreApproveStateModel {
  memoDetail: TransformedPreApproveData | null;
  saveAction: string | null;
  saveTimestamp: number | null;
  loaLevel: MemoLoaPreview[] | null;
  onApprove?: OnApproveAction | null;
  verificationAction: VerificationAction | null;
  phoneValidationError: boolean;
  nameValidationError: boolean;
  lastNameValidationError: boolean;
}

// Set the default state
export const defaults: PreApproveStateModel = {
  memoDetail: null,
  saveAction: null,
  saveTimestamp: null,
  loaLevel: null,
  verificationAction: null,
  phoneValidationError: false,
  nameValidationError: false,
  lastNameValidationError: false,
};
